import Vue from "vue";
import Axios from "axios";
import VueI18n from "vue-i18n";
import VueTippy, { TippyComponent } from "vue-tippy";
import moment from "moment";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import messages from "./messages";

import "font-awesome/css/font-awesome.css";

Vue.prototype.$http = Axios;
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(VueTippy, {
    directive: "tippy", // => v-tippy
    flipDuration: 0,
    popperOptions: {
        modifiers: {
            preventOverflow: {
                enabled: true
            }
        }
    }
});
Vue.component("tippy", TippyComponent);

const autoDetectLanguage = () => {
    const [lang] = (navigator.userLanguage || navigator.language)
        .replace("-", "_")
        .toLowerCase()
        .split("_");
    return lang;
};

const lang = "it" || autoDetectLanguage();
moment.locale(lang);

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: lang, // set locale
    messages, // set locale messages
    silentTranslationWarn: true
});

console.log("current language: " + lang);
store.dispatch("initStore").then(() => {
    new Vue({
        router,
        store: store,
        i18n,
        render: h => h(App)
    }).$mount("#app");
});
